{
  "version": "0",
  "url": "https://api.dev.join9am.com",
  "user": "hubert@hausegger-inc.com"
}